import { render, staticRenderFns } from "./SelectedCatchmentBox.vue?vue&type=template&id=04220064&scoped=true&"
import script from "./SelectedCatchmentBox.vue?vue&type=script&lang=js&"
export * from "./SelectedCatchmentBox.vue?vue&type=script&lang=js&"
import style0 from "./SelectedCatchmentBox.vue?vue&type=style&index=0&id=04220064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04220064",
  null
  
)

export default component.exports